import { render } from "./PageError.vue?vue&type=template&id=281c978e"
import script from "./PageError.vue?vue&type=script&lang=js"
export * from "./PageError.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PageError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "281c978e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('281c978e', __exports__)) {
    api.reload('281c978e', __exports__)
  }
  
  module.hot.accept("./PageError.vue?vue&type=template&id=281c978e", () => {
    api.rerender('281c978e', render)
  })

}


export default __exports__